const constants = require("./constants");
const date = require("./common/date");
const firebase = require("./firebase");
const waitlist = require("./waitlist");
const slotsApi = require("./slots");
const schedules = require("./schedule");

module.exports = {
  constants,
  ...constants,
  ...date,
  ...firebase,
  ...slotsApi,
  ...waitlist,
  ...schedules,
};
